import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { PatternlibCheckControlValueAccessor } from './directives/check-accessor';
import { WebComponentFormElementDirective } from './directives/webcomponent-form.directive';
import { PatternlibValueControlValueAccessor } from './directives/value-accessor';
import { PatternlibDatepickerControlValueAccessor } from './directives/datepicker-accessor';

@NgModule({
  declarations: [
    PatternlibCheckControlValueAccessor,
    WebComponentFormElementDirective,
    PatternlibValueControlValueAccessor,
    PatternlibDatepickerControlValueAccessor,
  ],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [
    PatternlibCheckControlValueAccessor,
    WebComponentFormElementDirective,
    PatternlibValueControlValueAccessor,
    PatternlibDatepickerControlValueAccessor,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PatternlibAngularFormsModule {}
